module.exports = __webpack_public_path__ + "dc47491e4d665d4a38ec00cb57796a56.MP3";